<template>
  <div>
    <div>
      <div class="qrcode-content">
        <!-- 顶部背景图 -->
        <div :style="{ backgroundImage: `url(${top})` }" class="bg-top"></div>
        <!-- 底部背景 -->
        <div class="bg-bottom"></div>
        <div class="qrcode">
          <!-- 二维码卡片 -->
          <img
              :src="codecard"
              class="codecard" alt="background-codecard">

          <!-- 二维码图像 -->
          <img :src="qrcodeUrl" class="qrcode-image" alt="二维码">
        </div>

      </div>
      <div class="bg-bottom text">
        <div class="cus">——&nbsp;&nbsp;{{ customer }}&nbsp;&nbsp;——</div>
        <div class="desc">{{ desc }}</div>
        <div class="id">ID：{{ id }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QrcodeM',

  props: {
    qrcodeUrl: String,
    id: "",
    desc: "",
    customer: "",
  },

  data() {
    return {
      top: "https://meefung-wellorg-prd-1256075047.cos.ap-guangzhou.myqcloud.com/manage-interface-static/imgs/qrcode_m_ele_top.svg",
      codecard: "https://meefung-wellorg-prd-1256075047.cos.ap-guangzhou.myqcloud.com/manage-interface-static/imgs/qrcode_m_ele_codecard.svg",
    };
  },
};
</script>

<style scoped>
.qrcode-content {
  position: relative;
  width: 400px;
  height: auto;
  display: flex;
  flex-direction: column;
}

.bg-top {
  width: 100%;
  height: 255px;
  -o-object-fit: cover;
  object-fit: cover;
  background-size: cover;
  box-sizing: border-box;
}

.qrcode {
  position: absolute;
  top: 66%;
  left: 50%;
}


.codecard {
  position: absolute;
  top: 58%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 380px;
  height: 380px;
  z-index: 1;
}

.bg-bottom {
  bottom: 0;
  height: 265px;
  background-color: #f6f7f8;
  box-sizing: border-box;
  width: 400px;
}

.text {
  height: auto;
  padding: 10px 20px 30px;
  font-weight: bold;
  color: #2b4a68;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
}

.qrcode-image {
  position: absolute;
  top: -42px;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 220px;
  height: 220px;
  z-index: 2;
}

.id {
  font-size: 19px;
  color: rgba(43, 74, 104, 0.33);
}


.desc {
  word-wrap: break-word; /* 强制换行 */
  white-space: normal; /* 允许正常换行 */
  width: 320px; /* 保持宽度一致 */
}

.cus{
  font-size: 17px;
  color: rgba(43, 74, 104, 0.32);
}

</style>
